import { ShipmentCompany, ShipmentMethod } from '../enums/shipmentMethod';
import { transformEnumToOptions } from '1_shared';

export const shipmentMethodOptions = transformEnumToOptions(ShipmentMethod);

export const shipmentCompanyOptions = transformEnumToOptions(ShipmentCompany);